<h2 mat-dialog-title>{{ data.title || 'WordPress Already installed' }}</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <div class="buttons">
    <button matButton="outlined" class="big-button" (click)="goToInstallation()">
      <div class="button-content">
        <fa-icon matPrefix [icon]="['fab', 'wordpress-simple']" size="xl"></fa-icon>
        <div class="texts">
          <h3>Install WordPress</h3>
          <span>Reinstall WordPress or install in subdirectory</span>
        </div>
      </div>
    </button>

    <button matButton="outlined" class="big-button" (click)="deleteWordpress()">
      <div class="button-content">
        <fa-icon matPrefix [icon]="['fas', 'trash']" size="xl"></fa-icon>
        <div class="texts">
          <h3>Delete WordPress</h3>
          <span>Remove all files and database content from the site.</span>
        </div>
      </div>
    </button>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="outlined" class="close-button" (click)="close()">
    {{ data.secondaryButtonText || 'Close' }}
  </button>
</mat-dialog-actions>
